import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";

//Extras
import { main } from "../../assets/coach-assets/constants/colors"
import { fontType } from "../../assets/extras";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth, db } from '../../assets/connections'
import { doc, getDoc } from "firebase/firestore";

//Components
import Snack from '../../components/snack'
import Loader from '../../components/loader'

const CoachLogin = () => {

    const navigate = useNavigate()

    const [data, setData] = useState({
        clave_profesor: "",
        correo_profesor: ""
    })
    const [shown, setShown] = useState(false)
    const [loading, setLoading] = useState(false)

    //Control del mensaje snack
    const showMessage = (message, status) => {
        setTimeout(() => {
            let contSnack = document.getElementById("contSnack")
    
            let snack = document.createElement("div")
            snack.classList.add("snack")
    
            snack.innerHTML = status == "success" ?
                "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #56d600;'></div>"
                : status == "warning" ?
                    "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                    : status == "error" ?
                        "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                        "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                        "<div className='snackBar' style='background-color: #c20000;'></div>"
                        : ""
    
            contSnack.appendChild(snack)
            setTimeout(() => {
                snack.remove()
            }, 5000)
        }, 5)
    }

    //Funciones que logean al usuario
    const onHandleLogin = () => {
        if (data.correo_profesor && data.clave_profesor) {
            setLoading(true)
            loggingin()
        } else {
            showMessage("Debes completar todos los campos", "warning")
        }
    }
    const loggingin = async () => {
        await signInWithEmailAndPassword(auth, data.correo_profesor, data.clave_profesor).then( async r => {
            const token = localStorage.setItem("authTokenCoach", JSON.stringify({
                correo_profesor: data.correo_profesor,
                clave_profesor: data.clave_profesor
            }))

            await getData(data.correo_profesor)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setLoading(false)
            if(e.code == "auth/wrong-password"){
                showMessage("Clave incorrecta", "error", 3000)
            } else if(e.code == "auth/user-not-found"){
                showMessage("Correo invalido", "error", 3000)
            } else if(e.code == "auth/quota-exceeded"){
                showMessage("Servicio temporalmente no disponible. Intenta en unos minutos.", "error", 5000)
            } else if(e.code == "auth/too-many-requests"){
                showMessage("Demasiados intentos. Intenta más tarde.", "error", 5000)
            } else if(e.code == "auth/network-request-failed"){
                showMessage("Error de red. Verifica tu conexión.", "error", 3000)
            } else if(e.code == "auth/invalid-email"){
                showMessage("Correo inválido", "error", 3000)
            } else {
                showMessage("Error: " + (e.message || "Error de conexión"), "error", 5000)
            }
        })
    }

    //Opcion que obtiene los datos del usuario logeado
    const getData = async (correo) => {
        console.log("Buscando profesor con correo:", correo)
        await getDoc(doc(db, "Profesores", correo)).then(r => {
            console.log("Documento existe:", r.exists())
            if(r.exists()){
                console.log("Datos del profesor:", r.data())
                navigate("/coach/home", {
                    state: {
                        academias: r.data().academia_profesor,
                        correo,
                        nombre_profesor: r.data().nombre_profesor + " " + r.data().apellido_p_profesor,
                        sedes_profesor: r.data().sedes_profesor || {}
                    }
                })
            } else {
                console.log("El documento Profesores/" + correo + " no existe en Firestore")
                setLoading(false)
                showMessage("Profesor no encontrado en la base de datos", "error", 3000)
            }
        }).catch(e => {
            console.log("Error obteniendo datos del profesor:", e.code, e.message)
            setLoading(false)
            showMessage("Error de conexion", "error", 3000)
        })
    }

    useEffect(() => {
        const token = localStorage.getItem("authTokenCoach")

        if(token) {
            navigate("/coach", {
                replace: true
            })
        }
    }, [])

    return (
        <div style={{
            flex: 1,
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }}>

            <Snack />

            <Loader
                loading={loading}
            />

            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                width: "90%",
                maxWidth: 700
            }}>
                <p style={{
                    fontSize: 30,
                    fontFamily: fontType.title,
                    marginBottom: 30
                }}>
                    INICIAR SESION
                </p>

                <div style={styles.contInputs}>
                    <input
                        style={styles.input}
                        value={data.correo_profesor}
                        onChange={e => setData({ ...data, correo_profesor: e.target.value.trim().toLowerCase() })}
                        placeholder="Correo"
                    />
                </div>

                <div style={{ ...styles.contInputs, position: "relative" }}>
                    <input
                        type={shown ? "text" : "password"}
                        style={styles.input}
                        value={data.clave_profesor}
                        onChange={e => setData({ ...data, clave_profesor: e.target.value })}
                        placeholder="Contraseña"
                    />
                    <button
                        style={{
                            marginTop: 5,
                            position: "absolute",
                            top: 4,
                            right: 25,
                            background: "transparent",
                            border: "none",
                            cursor: "pointer"
                        }}
                        onClick={() => setShown(!shown)}
                    >
                        {shown ? <FaEyeSlash size={20} color="gray" /> : <FaEye size={20} color="gray" />}
                    </button>
                </div>

                <div style={{ ...styles.contInputs, marginTop: 50 }}>
                    <button
                        style={{
                            padding: 15,
                            width: 150,
                            borderRadius: 20,
                            backgroundColor: main,
                            border: "none",
                            cursor: "pointer"
                        }}
                        onClick={onHandleLogin}
                    >
                        <span style={{ fontSize: 16, fontWeight: "bold", color: "white", fontFamily: fontType.title, letterSpacing: 3 }}>
                            INGRESAR
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}

const styles = {
    contInputs: {
        width: "80%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 10,
        marginBottom: 5
    },
    subtitles: {
        width: "95%",
        textAlign: "left",
        fontSize: 12
    },
    input: {
        textAlign: "center",
        fontSize: 16,
        height: 40,
        borderWidth: 1,
        width: "100%",
        borderRadius: 10,
        borderColor: "#aaa", color: "black"
    }
}

export default CoachLogin